import { TypographyProps, Typography } from "@mui/material";

const GatherlanceTypography = (props: TypographyProps) => {
  return <Typography {...props} fontFamily={"SF-Pro-Display"} />
}

export default GatherlanceTypography
